import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import { logger } from 'redux-logger';
import reducer from '../redux';


const middlewares = [];

if (process.env.NODE_ENV === 'development' || window.Cypress) {
  middlewares.push(logger);
}

const store = createStore(reducer, {}, composeWithDevTools(
  applyMiddleware(...middlewares),
  // other store enhancers if any
));


// Allow the e2e tests to programmatically update the store
if (window.Cypress) {
  window.store = store;
}

export default store;
